import Api from "@/utils/axios";
import newApi from "@/utils/axios-images";
export default {
  namespaced: true,
  state: {
    salesData:[],
    companyProducts:[],
    savedProducts:[],
    savedCompanies:[],
    productsRequests:[],
    productsRequestsDetails:{},
    paymentWays:{}
  },
  getters: {
    getSalesData(state){
      return state.salesData
    },
    getCompanyProducts(state){
      return state.companyProducts
    },
    getSavedProducts(state){
      return state.savedProducts
    },
    getSavedCompanies(state){
      return state.savedCompanies
    },
    getProductsRequests(state){
      return state.productsRequests
    },
    getProductsRequestsDetails(state){
      return state.productsRequestsDetails
    },
    getPaymentWays(state){
      return state.paymentWays
    },
  },
  mutations: {
    SET_Sales(state, sale){
      state.salesData = sale
    },
    SET_COMPANY_PRODUCTS(state, product){
      state.companyProducts = product
    },
    SET_SAVED_PRODUCTS(state, product){
      state.savedProducts = product
    },
    SET_SAVED_COMPANIES(state, company){
      state.savedCompanies = company
    },
    SET_PRODUCT_REQUESTS(state, request){
      state.productsRequests = request
    },
    SET_PRODUCT_REQUESTS_DETAILS(state, details){
      state.productsRequestsDetails = details
    },
    SET_PAYMENT_WAYS_DATA(state, pay){
      state.paymentWays = pay
    },
  },
  actions: {
    // Start Handler Sales Data -- With category id
    async handlerSalesData({commit}, id) {
      return await new Promise((resolve, reject) => {
        Api.get(`get-sales/${id}`).then((response)=>{
          commit("SET_Sales", response.data);
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    async handlerSalesDataAuth({commit}, id) {
      return await new Promise((resolve, reject) => {
        Api.get(`auth-get-sales/${id}`).then((response)=>{
          commit("SET_Sales", response.data);
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // End Handler Sales Data -- With category id

    // Handler Get Company Products -- Depends on the category id  and company id
    async handlerGetCompanyProducts({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.get(`get-company-product/${payload.companyId}/${payload.categoryId}`).then((response)=>{
          commit("SET_COMPANY_PRODUCTS", response.data);
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Auth
    async handlerGetCompanyProductsAuth({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.get(`auth-get-company-product/${payload.companyId}/${payload.categoryId}`).then((response)=>{
          commit("SET_COMPANY_PRODUCTS", response.data);
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Sales Data 
    async handlerMakeOrder({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.post("sale-order", payload).then((response)=>{
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Payment 
    async handlerPaymentOrder({commit}, payload) {
      return await new Promise((resolve, reject) => {
        newApi.post("order-submit", payload).then((response)=>{
    
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },

    //// Start Favorites
    // Handler Saved Products
    async handlerSavedProducts({commit}) {
      return await new Promise((resolve, reject) => {
        Api.get("get-saved-products").then((response)=>{
          commit("SET_SAVED_PRODUCTS", response.data);
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Saved Companies
    async handlerSavedCompanies({commit}) {
      return await new Promise((resolve, reject) => {
        Api.get("get-saved-companies").then((response)=>{
          commit("SET_SAVED_COMPANIES", response.data);
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    //// End Favorites

    // Handler Saved 
    async handlerSaved({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.post("save", payload).then((response)=>{
    
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    
       // Handler Product Requests
       async handlerProductRequests({commit}) {
        return await new Promise((resolve, reject) => {
          Api.get("orders").then((response)=>{
            commit("SET_PRODUCT_REQUESTS", response.data);
            resolve(response)
          }).catch((error)=>{
            reject(error)
          })
        })
      },
        // Handler Product Requests Details
    async handlerProductRequestsDetails({commit}, id) {
      return await new Promise((resolve, reject) => {
        Api.get(`order/${id}`).then((response)=>{
          commit("SET_PRODUCT_REQUESTS_DETAILS", response.data);
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Payment Ways 
    async handlerPaymentWays({commit }, id) {
      return await new Promise((resolve, reject) => {
        Api.get(`company-payment/${id}/2`).then((response)=>{
          let payWays = {
            cash:null,
            postdatedCheck:null,
            currentCheck:null,
            noWays:null,
            
          }
          
          if (response.data && response.data.length > 0) {
            response.data.forEach(element => {
              element.payments.forEach(ele => {
                if (ele == 1) {
                  payWays.cash = ele
                } else if(ele == 2){
                  payWays.postdatedCheck = ele
                } else if(ele == 3){
                  payWays.currentCheck = ele
                } 
                
              });
              payWays.noWays = false
            });
            // state.paymentWays = payWays
          } else {
            payWays.noWays = true
          }
          commit("SET_PAYMENT_WAYS_DATA", payWays);
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Search For Search Products
    async handlerSearchCompanyProducts({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.get(`auth-get-company-product/${payload.companyId}/${payload.categoryId}?sort_type=${payload.sort_type}`).then((response)=>{
          commit("SET_COMPANY_PRODUCTS", response.data);

          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Search About Companies Rate Not Auth And Auth
    async handlerSalesCompaniesRate({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.get(`get-sales/${payload.id}?sort_type=${payload.sort_type}`).then((response)=>{
          commit("SET_Sales", response.data);
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    async handlerSalesCompaniesRateAuth({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.get(`auth-get-sales/${payload.id}?sort_type=${payload.sort_type}`).then((response)=>{
          commit("SET_Sales", response.data);
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
  }
};
